import { createEl } from '../helpers/functions';
const {
  AbortController
} = window;
const storedSearchQueries = {};
class Autocomplete {
  constructor(_ref) {
    let {
      selector = '[type=search]',
      // string css selector || form with attrs action & data-suggest
      minLength = 1,
      // min chars for request
      autoFocus = true,
      appendToSelector = null,
      // string css selector
      classes = '',
      // string with additional css classes
      errorMessages = {
        minLength: 'Please type more then 1 symbols',
        noResults: 'No results'
      },
      // string | object
      listItemTag = 'li',
      topResultsTitle = 'Top results' // string
    } = _ref;
    this.$searchForm = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!this.$searchForm) return;
    this.$searchInput = this.$searchForm.querySelector('.js-solr-q') || this.$searchForm.querySelector('input');
    this.$autocompleteResult = this.$searchForm.querySelector('.autocomplete-result');
    this.$autocompleteList = this.$searchForm.querySelector('.autocomplete-list');
    this.action = this.$searchForm.getAttribute('action');
    this.suggest = this.$searchForm.getAttribute('data-suggest');
    this.name = this.$searchInput.getAttribute('name');
    this.topResultsTitle = this.$searchForm.dataset.topResultsTitle || topResultsTitle;
    this.minLength = minLength;
    this.autoFocus = autoFocus;
    this.appendToSelector = appendToSelector;
    this.classes = classes;
    this.valueBeforeOpen = '';
    this.errorMessages = {
      minLength: this.$searchForm.dataset.errorMinLength || errorMessages.minLength,
      noResults: this.$searchForm.dataset.errorNoResult || errorMessages.noResults
    };
    this.listItemTag = listItemTag;
    this.suggestRequestController = new AbortController();
    this.init();
  }
  init() {
    this.renderWrapper(this.$searchForm);
    this.addHandlers();
  }
  addHandlers() {
    this.$searchInput.addEventListener('input', () => {
      this.changeHandler();
    });
    this.$autocomplete.addEventListener('focusout', () => this.blurHandler());
    this.$autocomplete.addEventListener('focusin', () => this.focusHandler());
    this.$autocompleteResult.addEventListener('mouseleave', () => {
      this.removeSelectedClass();
    });
    this.$searchInput.addEventListener('keydown', e => {
      this.keyDownHandler(e);
    });
  }
  renderWrapper($el) {
    this.$autocomplete = createEl('div', {
      class: `autocomplete ${typeof this.classes === 'string' ? this.classes : ''}`,
      tabindex: '0'
    });
    if (this.appendToSelector === null) {
      this.$autocompleteResult = createEl('div', {
        class: 'autocomplete-result'
      });
      this.$autocompleteList = createEl('ul', {
        class: 'autocomplete-list'
      });
      this.$autocompleteResult.append(this.$autocompleteList);
    } else {
      this.$autocompleteResult = document.querySelector(this.appendToSelector);
    }
    $el.parentNode.insertBefore(this.$autocomplete, $el);
    this.$autocomplete.appendChild($el);
    if (this.appendToSelector === null) this.$autocomplete.appendChild(this.$autocompleteResult);
    this.close();
  }
  changeHandler() {
    this.abortSuggestRequest();
    if (this.$searchInput.value.length >= this.minLength) {
      this.suggestRequest(this.$searchInput.value);
    } else {
      this.error(this.errorMessages.minLength);
    }
  }
  keyDownHandler(e) {
    if (document.activeElement.classList.contains('js-solr-q')) {
      const $selectedElement = this.$autocompleteList.querySelector('.selected');
      const $a = $selectedElement && $selectedElement.querySelector('a');
      if (!this.$autocompleteResult.classList.contains('show')) return;
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        if ($selectedElement && $selectedElement.previousElementSibling) {
          const $prevEl = $selectedElement.previousElementSibling.classList.contains('autocomplete-title') ? $selectedElement.previousElementSibling.previousElementSibling : $selectedElement.previousElementSibling;
          this.setSelectedEl($prevEl, $prevEl.dataset.value);
        } else {
          this.$searchInput.value = this.valueBeforeOpen;
          this.removeSelectedClass();
        }
      }
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if ($selectedElement && $selectedElement.nextElementSibling) {
          const $nextEl = $selectedElement.nextElementSibling.classList.contains('autocomplete-title') ? $selectedElement.nextElementSibling.nextElementSibling : $selectedElement.nextElementSibling;
          this.setSelectedEl($nextEl, $nextEl.dataset.value);
        } else if (!$selectedElement) {
          const $firstLi = this.$autocompleteList.querySelector('li');
          this.setSelectedEl($firstLi, $firstLi.dataset.value);
        }
      }
      if (e.key === 'Enter' && $a) {
        e.preventDefault();
        if ($a) $a.click();
      }
    }
  }
  abortSuggestRequest() {
    this.suggestRequestController.abort();
    this.suggestRequestController = new AbortController();
    this.$autocompleteList.innerHTML = '';
  }
  suggestRequest(value) {
    const storedResponseDataStr = storedSearchQueries[value];
    if (storedResponseDataStr) {
      this.suggestRequestSuccess(storedResponseDataStr);
    } else {
      fetch(`${this.suggest}&tx_solr%5BqueryString%5D=${value}`, {
        signal: this.suggestRequestController.signal
      }).then(response => response.text()).then(dataStr => {
        this.suggestRequestSuccess(dataStr);
        storedSearchQueries[value] = dataStr;
      }).catch(() => {});
    }
  }
  suggestRequestSuccess(dataStr) {
    const {
      suggestions,
      suggestion,
      documents
    } = JSON.parse(dataStr);
    if (suggestions && suggestions) {
      this.$autocompleteList.innerHTML = '';
      this.renderList({
        suggestions: suggestions ? Object.keys(suggestions) : [],
        suggestion: suggestion || '',
        pages: documents || []
      });
    } else {
      this.error(this.errorMessages.noResults);
    }
  }
  renderList(_ref2) {
    let {
      suggestions,
      suggestion,
      pages
    } = _ref2;
    const listFragment = document.createDocumentFragment();
    const pagesFragment = document.createDocumentFragment();
    suggestions.forEach(item => {
      const $li = createEl(this.listItemTag, {
        class: 'autocomplete-item',
        tabindex: '0',
        'data-value': item
      }, item.replace(suggestion, `<b>${suggestion}</b>`));
      $li.addEventListener('click', () => this.chooseHandler($li));
      $li.addEventListener('mouseenter', () => this.setSelectedEl($li, null));
      listFragment.appendChild($li);
    });
    const $liTopResultsTitle = pages.length ? createEl(this.listItemTag, {
      class: 'autocomplete-item autocomplete-title'
    }, this.topResultsTitle) : null;
    pages.forEach(page => {
      const {
        link,
        title
      } = page;
      const aHtml = `<a href="${link}">${title}</a>`;
      const $li = createEl(this.listItemTag, {
        class: 'autocomplete-item'
      }, aHtml);
      pagesFragment.appendChild($li);
    });
    this.$autocompleteList.append(listFragment, $liTopResultsTitle, pagesFragment);
    if (document.activeElement === this.$searchInput) {
      this.open();
    }
  }
  error() {
    let content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'No result';
    let errorClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'autocomplete-result__empty';
    const $error = document.createElement(this.listItemTag);
    $error.classList.add(errorClass, 'autocomplete-error');
    $error.innerHTML = content;
    this.$autocompleteList.innerHTML = '';
    this.$autocompleteList.appendChild($error);
    this.open();
  }
  chooseHandler($el) {
    this.$searchInput.value = $el.innerText;
    this.close();
    this.submitHandler();
  }
  setSelectedEl($el, value) {
    this.removeSelectedClass();
    $el.classList.add('selected');
    if (value) {
      this.$searchInput.value = value;
    }
  }
  removeSelectedClass() {
    this.$autocompleteList.querySelectorAll('.selected').forEach($s => $s.classList.remove('selected'));
  }
  submitHandler() {
    const $form = this.$searchForm.closest('form');
    if (!$form) return;
    $form.classList.add('loading');
    $form.submit();
  }
  blurHandler() {
    this.close();
    this.$autocomplete.classList.remove('show');
  }
  focusHandler() {
    this.open();
  }
  close() {
    this.$autocompleteResult.classList.remove('show');
    this.removeSelectedClass();
    if (this.$searchInput.value && this.valueBeforeOpen !== this.$searchInput.value) {
      this.changeHandler();
    }
  }
  open() {
    if (this.$autocompleteList.querySelectorAll(this.listItemTag).length) {
      this.$autocompleteResult.classList.add('show');
      this.valueBeforeOpen = this.$searchInput.value;
    }
  }
}
export default Autocomplete;